import axios, { AxiosResponse } from "axios";
import { DeleteUserObj, UpdateUserObj } from "../../../shared/interfaces/components/card.interface";
import { ApiErrorHandler } from "../../../../errorHandler";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";
import { recoverResponseCode, recoverResponseData } from "../../../features/card/pages/card";

export const getTenantUserList = (tenantId: string) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${tenantId}/user?nextPage=&pageSize=`;
  return apiClient
    .get(URL)
    .then((response: AxiosResponse) => response.data)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const deleteUserRowRequest = (payload: DeleteUserObj) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${payload.tenantId}/user/${payload.usermail}`;
  return apiClient
    .delete(URL)
    .then((response: AxiosResponse) => {
      recoverResponseCode(response.status);
      recoverResponseData(response.data);
    })
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const updateUserRowRequest = (payload: UpdateUserObj) => {
  const bodyRequest = {
    newUserEmail: payload.newMail,
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${payload.tenantId}/user/${payload.usermail}`;
  const resp = axios.patch(URL, bodyRequest)
    .then((response: AxiosResponse) => {
      recoverResponseCode(response.status);
      recoverResponseData(response.data);
    })
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
  return resp;
};
